var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnkr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2075E8",
    d: "M12.887 5.357L17.37 7.66a1.94 1.94 0 0 1 1.058 1.735v.892h-1.714v-.892c0-.107 0-.214-.098-.261l-4.488-2.237a.3.3 0 0 0-.27 0L7.384 9.129c-.098.047-.098.154-.098.257v.9H5.57v-.892A1.95 1.95 0 0 1 6.63 7.66l4.483-2.302a1.95 1.95 0 0 1 1.774 0M13.286 12c0-.746-.549-1.286-1.286-1.286A1.26 1.26 0 0 0 10.714 12c-.008.737.506 1.277 1.286 1.286c.78.008 1.286-.54 1.286-1.286m3.33 2.871c.098-.051.098-.158.098-.265v-.892h1.714v.892a1.94 1.94 0 0 1-1.058 1.735l-4.479 2.302a1.95 1.95 0 0 1-1.778 0L6.63 16.34a1.94 1.94 0 0 1-1.059-1.735v-.892h1.715v.892c0 .111 0 .214.098.261l3.759 1.847v-1.928A2.79 2.79 0 0 1 9 12c0-1.693 1.191-3 3-3s3 1.286 3 3c0 1.444-.853 2.426-2.143 2.786v1.928z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnkr);
export default __webpack_public_path__ + "static/media/ankr.3927883c20fddc2e84342ad56db4950d.svg";
export { ForwardRef as ReactComponent };